import { LOCATIONS_ACTIONS } from 'constants/Actions/Locations';

// Estado inicial del reducer
const aInitialState = {
    aLocations: [],

    aLocationsList: [],
    nTotalPages: 0,
    oLocation: null,

    bIsSuccess: false,
    bIsError: false,
}
/**
 * Reducer que será utilizado para controlar los datos referidos a las ubicaciones almacenadas en el sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const LocationReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case LOCATIONS_ACTIONS.GET_LOCATIONS:
            return { ...aState, aLocations: oAction.data };
        case LOCATIONS_ACTIONS.GET_ALL:
            return { ...aState, aLocationsList: oAction.data.data, nTotalPages: oAction.data.pages };
        case LOCATIONS_ACTIONS.FIND:
            return { ...aState, oLocation: oAction.data };
        case LOCATIONS_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case LOCATIONS_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case LOCATIONS_ACTIONS.CLEAN:
            return { ...aState, bIsError: false, bIsSuccess: false, oLocation: null };
        default:
            return aState;
    }
}
